import { DatastoreInterface } from '@freelancer/datastore/core';
import { generateId } from '@freelancer/datastore/testing';
import {
  FolderApi,
  PrivacyLevelApi,
  ThreadTypeApi,
} from 'api-typings/messages/messages_types';
import { Thread, ThreadContext } from './threads.model';
import { ThreadsCollection } from './threads.types';

interface GenerateThreadsOptions {
  readonly userId: number;
  readonly otherMembers: ReadonlyArray<number>;
  readonly context: ThreadContext;
}

export async function createThread(
  datastore: DatastoreInterface,
  options: GenerateThreadsOptions,
) {
  const object = generateThread(options);
  await datastore.createRawDocument<ThreadsCollection>('threads', object);

  return object;
}

function generateThread(options: GenerateThreadsOptions): Thread {
  return {
    context: options.context,
    folder: FolderApi.INBOX,
    id: generateId(),
    isBlocked: false,
    isFake: false,
    isMuted: false,
    isRead: true,
    members: [options.otherMembers[0], options.userId],
    inactiveMembers: [],
    messageUnreadCount: 0,
    otherMembers: [options.otherMembers[0]],
    owner: options.userId,
    threadType: ThreadTypeApi.PRIVATE_CHAT,
    timeCreated: Date.now(),
    timeRead: Date.now(),
    timeUpdated: Date.now(),
    userReadTimes: {
      [options.userId]: Date.now(),
      [options.otherMembers[0]]: Date.now(),
    },
    writePrivacy: PrivacyLevelApi.MEMBERS,
  };
}
